module.exports = __webpack_public_path__ + "img/Close-up_The_Scarab_bioreactor_1.3ff127e9.webp";